export default {
  API_ENDPOINT: "https://vast-headland-68467.herokuapp.com/api",
  TOKEN_KEY: "blogful-client-auth-token"
};
